<template>
  <app-input
    ref="input"
    v-if="computedType"
    :type="computedType"
    v-model="model"
    :placeholder="computedPlaceholder"
    :options="computedOptions"
    :readonly="readonly"
    :disabled="disabled"
    @app-event="onAppEvent"/>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop, Inject } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

const debug = process.env.NODE_ENV === 'development';

@Component
export default class AppFormInput extends AppComponent {
  // 上位のフォームコンポーネントで公開されたフォームデータを参照
  @Inject('_app_form') form;

  @Prop({ required: true })
  prop;

  @Prop({ required: false, default: null })
  type;

  @Prop({ required: false, default: null })
  placeholder;

  @Prop({ required: false, default: false })
  disabled;

  @Prop({ required: false, default: false })
  readonly;

  @Prop({ required: false, default: null })
  options;

  // 次のフォーカス遷移先プロパティ名
  @Prop({ required: false })
  nextFocus;

  // 入力要素種別取得
  get computedType () {
    if (this.type !== null) {
      return this.type;
    } else {
      if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('type' in this.schema.props[this.prop])) {
        return this.schema.props[this.prop].type;
      } else {
        return null;
      }
    }
  }

  // Placeholder取得
  get computedPlaceholder () {
    if (this.placeholder !== null) {
      return this.placeholder;
    } else {
      if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('placeholder' in this.schema.props[this.prop])) {
        return this.schema.props[this.prop].placeholder;
      } else {
        return null;
      }
    }
  }

  // options取得
  get computedOptions () {
    // 下記をマージして返却する
    // スキーマで定義されたオプション
    // 要素に直接指定されたオプション
    let options = {};
    if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('options' in this.schema.props[this.prop])) {
      options = Object.assign(options, this.schema.props[this.prop].options);
    }
    if (this.options !== null) {
      options = Object.assign(options, this.options);
    }
    return options;
  }

  get model () {
    return this.form.model[this.prop];
  }

  set model (value) {
    // プロパティが不完全なモデル検知
    if (debug && (this.form.model) && (!(this.prop in this.form.model))) {
      console.warn(`Model has not prop [${this.prop}]`);
    }

    this.form.model[this.prop] = value;
    this.$emit('input', value);
  }

  get schema () {
    return this.form.schema;
  }

  // 親コンポーネントへの透過イベント
  onAppEvent (...args) {
    // propに対してバリデーションを実行する
    if (args[0] === 'require:validate') {
      if (this.form.validateField) {
        this.form.validateField([this.prop]);
      }
    }
    this.$emit('app-event', ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppFormInput.vue